import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { fetchSnapshotCSV } from "../../s3/FetchSnapshotData";

import "./snapshotsTable.css";

// Table to display available snapshots in the system
function SnapshotsTable({ data }) {
  const [selectedRow, setSelectedRow] = useState(null); // Track the selected row
  const navigate = useNavigate();
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);

  useEffect(() => {
    getS3().then(setS3);
  }, [])

  // getStatusClassName determines the CSS based on the status input
  // output: return CSS class - (each class has a different colour)
  function getStatusClassName(status) {
    switch (status) {
      case "In Progress":
        return "td-in-progress";
      case "Submitted":
        return "td-submitted";
      case "Requested":
        return "td-repx-requests";
      case "Generated":
        return "td-repx-reports";
      default:
        return "td";
    }
  }

  // Handle double-click on a row
  const handleRowDoubleClick = async (selectedFileName) => {
    await fetchSnapshotCSV(S3, selectedFileName, "Snapshots"); // Fetch data using the new function

    //use navigate to redirect to redirect to the input form page with the document name as a parameter
    navigate(`/inputform/${selectedFileName}`);
  };

  return (
    <div className="snapshots-tb-cnt">
    <table id="snapshots-table">
      <thead>
        <tr>
          <th></th>
          <th>Last Updated</th>
          <th>Name</th>
          <th>Status</th>
          <th>By</th>
        </tr>
      </thead>
      <tbody className="snapshots-body">
        {data.map((row, index) => (
          <tr
            key={index}
            className={selectedRow === index ? "clicked" : ""}
            onDoubleClick={() => handleRowDoubleClick(row.name)} // Handle double-click event
            onMouseEnter={() => setSelectedRow(index)} // Set selectedRow on mouse enter
            onMouseLeave={() => setSelectedRow(null)} // Reset selectedRow on mouse leave
          >
            <td>{row.name.toLowerCase().includes("repx") ? (<div className="repx-icon">REPX</div>) : ""}</td>
            <td>{row.date}</td>
            <td>{row.name}</td>
            <td className={getStatusClassName(row.status)}>{row.status}</td>
            <td>{row.by}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
}

export default SnapshotsTable;
